import React from "react";
import { Link } from "react-router-dom";
const ImageList = ({ items, id, ctime, getAllShots }) => {
  return (
    <div>
      {Object.keys(items).map(s => {
        const ss = items[s];
        return (
          <div key={s}>
            <h3>{ss.headline}</h3>
            <p>
              <Link
                to={`/semss/${id}/${ctime}/${encodeURIComponent(ss.domain)}`}
              >
                {ss.landingPage}
              </Link>{" "}
              {ss.hasSplitTest ? "🔀" : ""}
              {ss.hasSplitTest && <span>{ss.flagSplit ? "⚠️" : "✅"}</span>}
            </p>
            <p>
              <b>{ss.percentage}%</b> &middot; {ss.size}/{ss.total}
            </p>
            <div>
              {ss.shots.map(img => (
                <>
                  <img src={img} />
                </>
              ))}
              {ss.size > 3 && !ss.gotAllShots && (
                <a
                  href="#"
                  onClick={e => {
                    getAllShots(e, ss.allShotsId);
                  }}
                >
                  Get all ad shots
                </a>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default ImageList;
